import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material";
import Reports from "./Reports";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../../assets/theme";
import "../../assets/base.css";

createRoot(document.getElementById("reports")).render(
	<StrictMode>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<Reports />
		</ThemeProvider>
	</StrictMode>
);
